import { childComponents, childComponentsAsString } from './Container';
import { CustomBuilderComponents } from '@/helpers/enums';

export const containerBuilderConfigs = {
  name: CustomBuilderComponents.CONTAINER,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/extension-add.svg',
  inputs: [
    {
      name: 'Admin Tips',
      type: 'adminTips',
      defaultValue: `Accepts Child Components: ${childComponentsAsString}`,
    },
    {
      name: 'id',
      type: 'string',
      helperText: "ID's are useful for things like enabling anchor links",
    },
  ],
  childRequirements: {
    message: `You can only nest "${childComponentsAsString}" inside Container`,
    query: {
      'component.name': { $in: childComponents },
    },
  },
};
